// src/services/userRoleService.js

import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `${BACKEND_URL}/userroles`;

export const createUserRole = async (doctor) => {
  const response = await axios.post(API_URL, doctor);
  return response.data;
};

export const getAllUserRoles = async () => {
  const response = await axios.get(API_URL);
  return response.data;
}; 

export const updateUserRole = async (id, doctor) => {
  const response = await axios.put(`${API_URL}/${id}`, doctor);
  return response.data;
};

export const deleteUserRole = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};
